import { lazily } from '@mkmp/core'
import { ContentLayout } from '@/features/layout/ContentLayout'

const { OrgStructMain } = lazily(() => import('@/features/org-struct'))
const { NavMgmt } = lazily(() => import('@/features/nav'))
const { Application } = lazily(() => import('@/features/application'))
/**
 * 系统基础路由
 */
export default [
  {
    id: Symbol('org'),
    path: '/org',
    element: <ContentLayout />,
    children: [
      {
        id: Symbol('struct'),
        path: 'struct',
        handle: {
          code: 'org-struct'
        },
        element: <OrgStructMain />
      },
      {
        id: Symbol('org-app'),
        path: 'app',
        handle: {
          code: 'org-app'
        },
        element: <Application />
      },
      {
        id: Symbol('org-nav'),
        path: 'nav',
        element: <NavMgmt />,
        handle: {
          code: 'org-nav'
        }
      }
    ]
  }
]
